/* istanbul ignore file */
/* eslint-disable */

export const loadVWO = async () => {
  window._vwo_code ||
    (function () {
      var account_id = 305960,
        version = 2.1,
        settings_tolerance = 2000,
        hide_element = 'body',
        hide_element_style =
          'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important;transition:none !important;',
        /* DO NOT EDIT BELOW THIS LINE */
        f = false,
        w = window,
        d = document,
        v = d.querySelector('#vwoCode'),
        cK = '_vwo_' + account_id + '_settings',
        cc = {}
      try {
        var c = JSON.parse(
          localStorage.getItem('_vwo_' + account_id + '_config')
        )
        cc = c && typeof c === 'object' ? c : {}
      } catch (e) {}
      var stT = cc.stT === 'session' ? w.sessionStorage : w.localStorage
      var code = {
        nonce: v && v.nonce,
        use_existing_jquery: function () {
          return typeof use_existing_jquery !== 'undefined'
            ? use_existing_jquery
            : undefined
        },
        library_tolerance: function () {
          return typeof library_tolerance !== 'undefined'
            ? library_tolerance
            : undefined
        },
        settings_tolerance: function () {
          return cc.sT || settings_tolerance
        },
        hide_element_style: function () {
          return '{' + (cc.hES || hide_element_style) + '}'
        },
        hide_element: function () {
          if (performance.getEntriesByName('first-contentful-paint')[0]) {
            return ''
          }
          return typeof cc.hE === 'string' ? cc.hE : hide_element
        },
        getVersion: function () {
          return version
        },
        finish: function (e) {
          if (!f) {
            f = true
            var t = d.getElementById('_vis_opt_path_hides')
            if (t) t.parentNode.removeChild(t)
            if (e)
              new Image().src =
                'https://dev.visualwebsiteoptimizer.com/ee.gif?a=' +
                account_id +
                e
          }
        },
        finished: function () {
          return f
        },
        addScript: function (e) {
          var t = d.createElement('script')
          t.type = 'text/javascript'
          if (e.src) {
            t.src = e.src
          } else {
            t.text = e.text
          }
          v && t.setAttribute('nonce', v.nonce)
          d.getElementsByTagName('head')[0].appendChild(t)
        },
        load: function (e, t) {
          var n = this.getSettings(),
            i = d.createElement('script'),
            r = this
          t = t || {}
          if (n) {
            i.textContent = n
            d.getElementsByTagName('head')[0].appendChild(i)
            if (!w.VWO || VWO.caE) {
              stT.removeItem(cK)
              r.load(e)
            }
          } else {
            var o = new XMLHttpRequest()
            o.open('GET', e, true)
            o.withCredentials = !t.dSC
            o.responseType = t.responseType || 'text'
            o.onload = function () {
              if (t.onloadCb) {
                return t.onloadCb(o, e)
              }
              if (o.status === 200 || o.status === 304) {
                _vwo_code.addScript({ text: o.responseText })
              } else {
                _vwo_code.finish('&e=loading_failure:' + e)
              }
            }
            o.onerror = function () {
              if (t.onerrorCb) {
                return t.onerrorCb(e)
              }
              _vwo_code.finish('&e=loading_failure:' + e)
            }
            o.send()
          }
        },
        getSettings: function () {
          try {
            var e = stT.getItem(cK)
            if (!e) {
              return
            }
            e = JSON.parse(e)
            if (Date.now() > e.e) {
              stT.removeItem(cK)
              return
            }
            return e.s
          } catch (e) {
            return
          }
        },
        init: function () {
          if (d.URL.indexOf('__vwo_disable__') > -1) return
          var e = this.settings_tolerance()
          w._vwo_settings_timer = setTimeout(function () {
            _vwo_code.finish()
            stT.removeItem(cK)
          }, e)
          var t
          if (this.hide_element() !== 'body') {
            t = d.createElement('style')
            var n = this.hide_element(),
              i = n ? n + this.hide_element_style() : '',
              r = d.getElementsByTagName('head')[0]
            t.setAttribute('id', '_vis_opt_path_hides')
            v && t.setAttribute('nonce', v.nonce)
            t.setAttribute('type', 'text/css')
            if (t.styleSheet) t.styleSheet.cssText = i
            else t.appendChild(d.createTextNode(i))
            r.appendChild(t)
          } else {
            t = d.getElementsByTagName('head')[0]
            var i = d.createElement('div')
            i.style.cssText =
              'z-index: 2147483647 !important;position: fixed !important;left: 0 !important;top: 0 !important;width: 100% !important;height: 100% !important;background: white !important;'
            i.setAttribute('id', '_vis_opt_path_hides')
            i.classList.add('_vis_hide_layer')
            t.parentNode.insertBefore(i, t.nextSibling)
          }
          var o = window._vis_opt_url || d.URL,
            s =
              'https://dev.visualwebsiteoptimizer.com/j.php?a=' +
              account_id +
              '&u=' +
              encodeURIComponent(o) +
              '&vn=' +
              version
          if (w.location.search.indexOf('_vwo_xhr') !== -1) {
            this.addScript({ src: s })
          } else {
            this.load(s + '&x=true')
          }
        }
      }
      w._vwo_code = code
      code.init()
    })()

  var VWO_EXPERIMENTS_STORAGE_KEY = 'vwo_experiments'

  /**
   * Get VWO experiments from localStorage
   * @returns {Object} Object with experiment IDs as keys
   */
  function _getVwoExperimentsFromStorage() {
    try {
      var stored = localStorage.getItem(VWO_EXPERIMENTS_STORAGE_KEY)
      return stored ? JSON.parse(stored) : {}
    } catch (e) {
      return {}
    }
  }

  /**
   * Save VWO experiments to localStorage
   * @param {Object} experiments - Object with experiment IDs as keys
   */
  function _saveVwoExperimentsToStorage(experiments) {
    try {
      localStorage.setItem(
        VWO_EXPERIMENTS_STORAGE_KEY,
        JSON.stringify(experiments)
      )
    } catch (e) {
      console.warn('Failed to save VWO experiments to localStorage:', e)
    }
  }

  /**
   * Get experiment name from VWO's global _vwo_exp object
   * @param {number} experimentId - The experiment ID
   * @returns {string|null} The experiment name or null if not available
   */
  function _getExperimentName(experimentId) {
    if (
      typeof window._vwo_exp !== 'undefined' &&
      window._vwo_exp[experimentId] &&
      window._vwo_exp[experimentId].name
    ) {
      return window._vwo_exp[experimentId].name
    }
    return null
  }

  /**
   * Get variation name from VWO's global _vwo_exp object or use fallback naming
   * @param {number} experimentId - The experiment ID
   * @param {number} variationId - The variation ID
   * @returns {string} The variation name
   */
  function _getVariationName(experimentId, variationId) {
    if (
      typeof window._vwo_exp !== 'undefined' &&
      window._vwo_exp[experimentId] &&
      window._vwo_exp[experimentId].comb_n &&
      window._vwo_exp[experimentId].comb_n[variationId]
    ) {
      return window._vwo_exp[experimentId].comb_n[variationId]
    }

    if (variationId === 1) {
      return 'control'
    } else if (variationId > 1) {
      return 'variation_' + (variationId - 1)
    }
    return 'control'
  }

  /**
   * Store experiment data in localStorage for admin tool access
   * @param {number} experimentId - The experiment ID
   * @param {string|null} experimentName - The experiment name
   * @param {string} variationName - The variation name
   */
  function _storeExperimentData(experimentId, experimentName, variationName) {
    var experiments = _getVwoExperimentsFromStorage()
    experiments[experimentId] = {
      experimentName: experimentName,
      variationName: variationName
    }
    _saveVwoExperimentsToStorage(experiments)
  }

  /**
   * Push ALL current experiment data to Elbwalker user scope as a single object
   * Structure will be: vwo_active_experiments: { "123": "control", "124": "variant-1" }
   */
  function _pushToElbwalker() {
    if (typeof window.elb !== 'function') return

    // 1. Get the full detailed object from storage
    var storedExperiments = _getVwoExperimentsFromStorage()

    // 2. Map it to a simplified ID:Variant structure for the Data Warehouse
    var simplifiedExperiments = {}

    for (var id in storedExperiments) {
      if (storedExperiments.hasOwnProperty(id)) {
        // Ensure variation name is lowercase for consistency
        simplifiedExperiments[id] =
          storedExperiments[id].variationName.toLowerCase()
      }
    }

    // 3. Push to 'walker user' with a FIXED key
    // This updates the user state with the complete list of active tests
    window.elb('walker user', {
      vwo_active_experiments: simplifiedExperiments
    })

    console.log(
      'WalkerOS: Synced VWO experiments to user state',
      simplifiedExperiments
    )
  }

  /**
   * Handle VWO variation applied callback
   * @param {Array} data - VWO callback data: [eventName, experimentId, variationId]
   */
  function _handleVariationApplied(data) {
    if (!data) return

    var experimentId = data[1]
    var variationId = data[2]

    if (!experimentId || !variationId) return

    var experimentName = _getExperimentName(experimentId)
    var variationName = _getVariationName(experimentId, variationId)

    // First store the new data
    _storeExperimentData(experimentId, experimentName, variationName)

    // Then push the UPDATED full state to Elbwalker
    _pushToElbwalker()
  }

  function _setupVwoElbwalkerIntegration() {
    if (window._vwoElbwalkerIntegrationSetup) {
      return
    }
    window.VWO = window.VWO || []
    window.VWO.push(['onVariationApplied', _handleVariationApplied])
    window._vwoElbwalkerIntegrationSetup = true
  }

  _setupVwoElbwalkerIntegration()

  if (typeof window !== 'undefined') {
    window._vwoIntegration = {
      _getVwoExperimentsFromStorage,
      _saveVwoExperimentsToStorage,
      _getExperimentName,
      _getVariationName,
      _storeExperimentData,
      _pushToElbwalker,
      _handleVariationApplied,
      _setupVwoElbwalkerIntegration
    }
  }
}
